import * as React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

import { Popup, UserAvatar } from 'components';
import { IUser } from 'models';
import { EUserRole } from 'enums';

export const createUsersTableData = (isAdmin: boolean) => (user: IUser) => {
  const { editUser, assignBuilding, revokeAccess } = user;
  const selectedUserIsAdmin = user.roles?.findIndex((role) => role.name === EUserRole.ADMIN) > -1;

  const options = [
    {
      id: 1,
      label: 'Edit User',
      onClick: () => {
        editUser(user);
      },
    },
  ];
  if (isAdmin && !selectedUserIsAdmin) {
    options.push({
      id: 3,
      label: 'Assigned Buildings',
      onClick: () => {
        assignBuilding(user);
      },
    });
  }
  if (user.roles.length > 0) {
    options.push({
      id: 2,
      label: 'Revoke Access',
      onClick: () => {
        revokeAccess(user);
      },
    });
  }

  return {
    userId: user.id,
    userName: (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <UserAvatar imageUrl={user.profile_photo?.url || undefined} />
        <Typography
          variant="body2"
          sx={{
            marginLeft: 2,
          }}
        >
          {user.name}
        </Typography>
      </Box>
    ),
    EmployeeCode: <Typography> {user.code} </Typography>,
    Role: (() => {
      let role = 'No Access';
      const roles = user.roles.map((role) => role.name);
      if (roles.includes(EUserRole.ADMIN)) {
        role = 'Admin';
      } else if (roles.includes(EUserRole.BASIC)) {
        role = 'Basic';
      }

      return <Typography variant="body2">{role}</Typography>;
    })(),
    actions: (
      <Popup items={options} width={190}>
        <IconButton color="primary" size="small">
          <MoreHoriz />
        </IconButton>
      </Popup>
    ),
  };
};

export const convertUsersToTableData = (isAdmin: boolean) => (users: Array<IUser>) => {
  return users.map((user) => createUsersTableData(isAdmin)(user));
};

export const getImageRefreshed = (imageObj: any) => {
  if (!imageObj || !imageObj?.url) {
    return imageObj;
  }

  return {
    ...imageObj,
    url: `${imageObj.url}?${Date.now()}`,
  };
};
